export default {
  supportedNetworks: ['visa', 'masterCard'],
  merchantCapabilities: [
    'supports3DS',
    'supportsCredit',
    'supportsDebit'
  ]
}
